export const metricsAccountNameToPersesName = (name) => {
    return `${name} (Prometheus)`;
};
export const metricsAccountIdToPersesKey = (accountId) => {
    return `prom-${accountId}`;
};
/**
 * The inverse of {@link metricsAccountIdToPersesKey}. `undefined` for anything that isn't a `prom-<digits>` key —
 * a Lucene datasource slug, a legacy name-based reference, an unresolved `$variable` — so a caller reports
 * "unresolved" rather than querying a guessed account.
 */
export const persesKeyToMetricsAccountId = (key) => {
    const match = /^prom-(\d+)$/.exec(key);
    return match ? Number(match[1]) : undefined;
};
//# sourceMappingURL=perses-helpers.js.map